import { IQuestionPart, QuestionPartType } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { AnswersType } from './interface';

export function calculateMaxAnswersLength(content: IQuestionPart[]): number {
    if (!Array.isArray(content)) {
        return 0;
    }
    return content.reduce((initial, acc) => {
        if (acc.type === QuestionPartType.InputBox) {
            return initial + 1;
        }
        return initial;
    }, 0);
}

export function getAreaId(options: AnswersType = {}): number {
    const list: string[] = Object.keys(options);
    const len: number = list.length;
    let areaId = len;

    if (len > 0) {
        const lastKey: number = +list[len - 1];

        const numbers: number[] = new Array(lastKey + 1)
            .fill(null)
            .map((_v, i) => i);

        if (numbers.length === len) {
            return areaId;
        }
        areaId = numbers.find((i) => !list.includes(i.toString()));
    }
    return areaId;
}

export const getQuestionItemClassName = ({
    isActive,
    isFilled,
}: {
    isActive?: boolean;
    isFilled?: boolean;
} = {}): string => {
    if (isActive) {
        return 'active';
    }

    if (isFilled) {
        return 'filled';
    }

    return '';
};
